import { useInstanceId } from 'shared/src/hooks';
import { useGoodsSno } from './useGoodsSno';

export const useGoodsInstanceId = (key: string) => {
  const instanceId = useInstanceId();
  const sno = useGoodsSno();

  return `${instanceId}-${sno}-${key}`;
};
